import { useEffect, useState } from "react";
import { api, API, getToken } from "../../lib/api";
import { AdminNav } from "../../components/admin/AdminNav";
import { formatDateTime } from "../../lib/format";
import { Download, Loader2, Trash2, Mail, Phone } from "lucide-react";
import { toast } from "sonner";

export default function AdminLeadsPage() {
  const [leads, setLeads] = useState(null);

  const load = () => api.get("/admin/leads").then((r) => setLeads(r.data)).catch(() => setLeads([]));
  useEffect(() => { load(); }, []);

  const exportCsv = () => {
    const token = getToken();
    const url = `${API}/admin/leads/export?token=${encodeURIComponent(token)}`;
    window.open(url, "_blank");
  };

  const remove = async (id) => {
    try { await api.delete(`/admin/leads/${id}`); load(); toast.success("Lead eliminato"); }
    catch { toast.error("Errore"); }
  };

  return (
    <div className="min-h-screen bg-[#F4F8FF]">
      <AdminNav />
      <div className="px-6 md:px-10 max-w-[1400px] mx-auto py-10">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h1 className="font-heading text-4xl font-light text-[#0B1220]">Lead</h1>
            <p className="text-[#5C6678] mt-1">
              {leads === null ? "Caricamento…" : `${leads.length} richieste ricevute`}
            </p>
          </div>
          <button
            data-testid="export-csv-btn"
            onClick={exportCsv}
            className="inline-flex items-center gap-2 bg-[#1452F0] text-[#F4F8FF] hover:bg-[#0E3DC0] transition-colors rounded-sm px-6 py-3 text-sm font-medium"
          >
            <Download className="h-4 w-4" /> Esporta CSV
          </button>
        </div>

        {leads === null ? (
          <div className="py-20 flex justify-center"><Loader2 className="h-8 w-8 animate-spin text-[#1452F0]" /></div>
        ) : leads.length === 0 ? (
          <div className="py-20 text-center text-[#5C6678]">Nessun lead ricevuto al momento.</div>
        ) : (
          <div className="bg-white rounded-sm border border-[#D5DEEE] overflow-x-auto">
            <table className="w-full text-sm" data-testid="leads-table">
              <thead>
                <tr className="border-b border-[#D5DEEE] text-left text-[#5C6678] text-xs uppercase tracking-wider">
                  <th className="px-5 py-4 font-medium">Data</th>
                  <th className="px-5 py-4 font-medium">Nominativo</th>
                  <th className="px-5 py-4 font-medium">Contatti</th>
                  <th className="px-5 py-4 font-medium hidden lg:table-cell">Corso</th>
                  <th className="px-5 py-4 font-medium hidden lg:table-cell">Origine</th>
                  <th className="px-5 py-4 font-medium"></th>
                </tr>
              </thead>
              <tbody>
                {leads.map((l) => (
                  <tr key={l.id} className="border-b border-[#D5DEEE] last:border-0 hover:bg-[#E9EFFA]/50 align-top" data-testid={`lead-row-${l.id}`}>
                    <td className="px-5 py-4 text-[#5C6678] whitespace-nowrap text-xs">{formatDateTime(l.created_at)}</td>
                    <td className="px-5 py-4">
                      <div className="font-medium text-[#0B1220]">{l.name} {l.surname}</div>
                      <div className="text-xs text-[#5C6678]">{l.city} {l.profession ? `· ${l.profession}` : ""}</div>
                    </td>
                    <td className="px-5 py-4">
                      <a href={`mailto:${l.email}`} className="flex items-center gap-1.5 text-[#1452F0] hover:underline"><Mail className="h-3.5 w-3.5" />{l.email}</a>
                      {l.phone && <div className="flex items-center gap-1.5 text-[#5C6678] text-xs mt-1"><Phone className="h-3 w-3" />{l.phone}</div>}
                    </td>
                    <td className="px-5 py-4 hidden lg:table-cell text-[#5C6678]">{l.course_title || "—"}</td>
                    <td className="px-5 py-4 hidden lg:table-cell">
                      <span className="inline-block px-2 py-1 rounded-full text-xs bg-[#D5DEEE] text-[#5C6678]">{l.source}</span>
                      {l.marketing_consent && <span className="ml-1 inline-block px-2 py-1 rounded-full text-xs bg-[#1452F0]/15 text-[#1452F0]">mkt</span>}
                    </td>
                    <td className="px-5 py-4 text-right">
                      <button onClick={() => remove(l.id)} className="p-2 rounded-sm hover:bg-[#A63C3C]/10 text-[#A63C3C]" data-testid={`delete-lead-${l.id}`}>
                        <Trash2 className="h-4 w-4" />
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
